import { useEffect } from 'react';

export default function usePageTitle(title) {
    useEffect(() => {
        document.title = title ? `${title} | Celeritas` : 'Celeritas — iRacing League Manager';
        return () => { document.title = 'Celeritas — iRacing League Manager'; };
    }, [title]);
}
